export enum AddressScreenTrackingType {
  Escrow = 'escrow',
  SettingsBillingAddress = 'settings_billing_address',
  SettingsShippingAddress = 'settings_shipping_address',
  SettingsBalanceActivation = 'settings_balance_activation',
}
